import { render } from "./DrShashwatSingh.vue?vue&type=template&id=2f83c7b6"
import script from "./DrShashwatSingh.vue?vue&type=script&lang=js"
export * from "./DrShashwatSingh.vue?vue&type=script&lang=js"

import "./DrShashwatSingh.vue?vue&type=style&index=0&id=2f83c7b6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__